import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-route-indent-details',
  templateUrl: './route-indent-details.component.html',
  styleUrls: ['./route-indent-details.component.scss']
})
export class RouteIndentDetailsComponent implements OnInit {
  product_details: [] = [];
  route_details: any = {};
  constructor(
    public dialogRef: MatDialogRef<RouteIndentDetailsComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {
    console.log(data);
    this.getRouteIndentDetials()
  }

  ngOnInit() {
  }

  getRouteIndentDetials() {
    this.http.getRouteIndentDetails(this.data).subscribe((res_data: []) => {
      console.log(res_data);
      this.product_details = res_data['product_details'];
      console.log(this.product_details);
      this.route_details = res_data['route_details'];
    }, (error) => {
      console.log(error);
    });
  }

  closeComponent() {
    this.dialogRef.close();
  }

}
